import ActionsForm from '@/shared/mixins/actionsForm'
import addCourseApr from '../addCourseApr/addCourseApr.vue'
import APRTemplateCursosNRRepository from '@/shared/http/repositories/business/aprCoursesNR'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  props: ['aprId', 'revisao', 'aprTemplateReprovado', 'templateClonado'],
  name: 'nrCourseTable',
  components: {addCourseApr},
  mixins: [ActionsForm],
  data () {
    return {
      columTemplate: ['Curso NR', 'STATUS', 'TIPO DE MUDANÇA', 'DATA DE CADASTRO', ''],
      dataCursosNRTemplateAPR: [],
      dataCursosNRBusca: {}
    }
  },
  watch: {
    templateClonado (newValue) {
      if ((newValue !== null || newValue !== undefined) && newValue.id !== this.aprId) {
        this.dataCursosNRBusca = {APRId: newValue.id, Revisao: newValue.revisao}
        APRTemplateCursosNRRepository.GetAPRTemplateCursosNRGrid(this.$refs.tableGridsTemplateAprCursosNR.pagingLimit, this.$refs.tableGridsTemplateAprCursosNR.pagingIndex, this.dataCursosNRBusca)
          .then((Response) => {
            loading.pop()
            this.dataCursosNRTemplateAPR = Response.data.data
          }).catch(Error => {
            loading.pop()
            toast.error('Erro ao carregar as informações')
          })
      }
    }
  },
  methods: {
    popUptAddcursosNR () {
      this.$refs['add-cursosNR'].show()
    },
    cancelarCursosNR () {
      this.$refs['add-cursosNR'].hide()
    },
    onLoad (value) {
      if (this.revisao !== -1 || value != null) {
        loading.push()
        if (value !== undefined && value !== null) {
          this.dataCursosNRBusca = {APRId: this.aprId, Revisao: value}
          APRTemplateCursosNRRepository.GetAPRTemplateCursosNRGrid(this.$refs.tableGridsTemplateAprCursosNR.pagingLimit, this.$refs.tableGridsTemplateAprCursosNR.pagingIndex, this.dataCursosNRBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprCursosNR.LoadAllByData(Response)
              this.dataCursosNRTemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
            })
        } else {
          this.dataCursosNRBusca = {APRId: this.aprId, Revisao: this.revisao}
          APRTemplateCursosNRRepository.GetAPRTemplateCursosNRGrid(this.$refs.tableGridsTemplateAprCursosNR.pagingLimit, this.$refs.tableGridsTemplateAprCursosNR.pagingIndex, this.dataCursosNRBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprCursosNR.LoadAllByData(Response)
              this.dataCursosNRTemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
            })
        }
      }
    },
    AdicionarTableCursosNR (value) {
      this.dataCursosNRTemplateAPR.push(...value)
      this.$refs['add-cursosNR'].hide()
    },
    DeletePopup (value) {
      loading.push()
      if (value.AgEnvio !== undefined && value.AgEnvio !== null && value.AgEnvio !== false) {
        this.dataCursosNRTemplateAPR = this.dataCursosNRTemplateAPR.filter(cursoNR => cursoNR.cursosNRId !== value.cursosNRId)
        this.$emit('removerListaDeAlteracoesCursosNR', value)
        loading.pop()
      } else {
        for (let i = 0; i < this.dataCursosNRTemplateAPR.length; i++) {
          if (this.dataCursosNRTemplateAPR[i].cursosNRId === value.cursosNRId) {
            this.dataCursosNRTemplateAPR[i].statusAprovacao = null
            this.dataCursosNRTemplateAPR[i].statusAprovacaoDescricao = 'AG. ENVIO'
            this.dataCursosNRTemplateAPR[i].tipoMudanca = 'AG. ENVIO EXCLUSÃO'
            this.dataCursosNRTemplateAPR[i].dateCricaoFormatada = null
            let dados = {
              APRId: this.aprId,
              CursosNR: value.cursosNRId,
              APRAgAprovacaoId: value.arpTemplateAgAprovacaoId
            }
            this.$emit('excluirCursosNR', dados)
          }
        }
        loading.pop()
      }
      loading.pop()
    },
    salvarCursosNR (valeu) {
      this.$emit('salvarCursosNR', valeu)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/courseNR/courseNR.js